import PropTypes from "prop-types";
import { Component } from "react";
import { Col, Row } from "react-bootstrap";
import FormButtonsForCloseAndSubmit from "../../Common/Forms/FormButtonsForCloseAndSubmit";
import FromToDatePickerNative from "../../Common/Forms/FromToDatePickerNative";
import TextInput from "../../Common/Forms/TextInput";

export default class VentilstillingFilterForm extends Component {
  static propTypes = {
    showSokSpinner: PropTypes.bool,
    VentilstillingFilterFormState: PropTypes.shape({
      fraDato: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      tilDato: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      kjennemerke: PropTypes.string,
    }),
    handleChange: PropTypes.func,
    onSubmit: PropTypes.func,
    handleChangeToInitState: PropTypes.func,
    error: PropTypes.string,
  };

  render() {
    const {
      showSokSpinner,
      VentilstillingFilterFormState,
      handleChange,
      handleSubmit,
      handleChangeToInitState,
      error,
    } = this.props;
    return (
      <div className="SearchHistorikkForm">
        <div className="searchHistorikkOverskrift">Søk i tabellen</div>
        <div className="filter-flexbox-container ventilstilling-filter-flexbox">
          <FromToDatePickerNative
            fra={{
              id: "fraDato",
              name: "fraDato",
              label: "Dato fra",
              placeholder: "Velg dato",
              value: VentilstillingFilterFormState.fraDato,
              validationError:
                VentilstillingFilterFormState.fraDatoValidationErrorText,
            }}
            til={{
              id: "tilDato",
              name: "tilDato",
              label: "Dato til",
              placeholder: "Velg dato",
              value: VentilstillingFilterFormState.tilDato,
              validationError:
                VentilstillingFilterFormState.tilDatoValidationErrorText,
            }}
            onChange={handleChange}
          />
          <TextInput
            id="kjennemerke"
            name="kjennemerke"
            label="Kjennemerke"
            placeholder="Kjennemerke"
            value={VentilstillingFilterFormState.kjennemerke}
            onChange={handleChange}
          />
        </div>
        <div style={{ marginTop: 10 }}>
          <FormButtonsForCloseAndSubmit
            closeText="Tilbakestill"
            submitText="Søk"
            onSubmit={handleSubmit}
            onClose={handleChangeToInitState}
            showCloseSpinner={false}
            showSubmitSpinner={showSokSpinner}
          />
        </div>
        <Row>
          <Col md={12}>{error}</Col>
        </Row>
      </div>
    );
  }
}
